import { z } from 'zod';

export const runbookStepSchema = z.object({
  title: z.string()
    .min(1, 'Step title is required')
    .max(200, 'Step title must be 200 characters or less'),
  description: z.string()
    .max(1000, 'Step description must be 1000 characters or less')
    .optional(),
  action: z.string()
    .max(100, 'Action must be 100 characters or less')
    .optional(),
  automated: z.boolean().default(false),
});

export const runbookFormSchema = z.object({
  name: z.string()
    .min(1, 'Runbook name is required')
    .max(200, 'Runbook name must be 200 characters or less'),
  description: z.string()
    .min(1, 'Description is required')
    .max(1000, 'Description must be 1000 characters or less'),
  serviceId: z.string()
    .min(1, 'Please select a service'),
  trigger: z.string()
    .min(1, 'Trigger is required')
    .max(500, 'Trigger must be 500 characters or less'),
  steps: z.array(runbookStepSchema)
    .min(1, 'At least one step is required'),
});

export type RunbookFormData = z.infer<typeof runbookFormSchema>;
export type RunbookStepFormData = z.infer<typeof runbookStepSchema>;
